import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
  @Input() buttonName: any;
  @Input() textButton: boolean = false;
  @Input() blackTextButton: boolean = false;
  @Input() borderButton: boolean = false;
  @Input() shineButton: boolean = false;
  @Input() iconName: any;
  @Input() innerHtmlButtonName?: any;
  @Input() disabled: boolean = false;
  @Output() onClickEvent = new EventEmitter();

  constructor() { }

  ngOnInit() { }

  onClickAction() {
    this.onClickEvent.emit();
  }
}
